import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer style={{ backgroundColor: '#0A101A' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-3 gap-8">
          {/* Logo & Description */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="flex flex-col">
                <img 
                  src="/logo-transparent.png" 
                  alt="E-E-A-Tチェッカー" 
                  className="h-8 w-auto"
                />
                <span className="text-slate-500 text-[9px] mt-0.5">Powered by ミライトマッチ</span>
              </div>
            </div>
            <p className="text-slate-400 text-sm max-w-md mb-4">
              E-E-A-T（経験・専門性・権威性・信頼性）と独自性を
              5段階スコアで相対評価。改善ポイントを具体的にレポートします。
            </p>
            <p className="text-slate-500 text-xs">
              ※ 本ツールは検索順位を保証するものではありません
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">関連リンク</h4>
            <ul className="space-y-2">
              <li>
                <a
                  href="https://miwrite-match.jp/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-slate-400 hover:text-cyan-400 text-sm transition-colors"
                >
                  ミライトマッチ
                </a>
              </li>
              <li>
                <a
                  href="https://it-plucktice.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-slate-400 hover:text-cyan-400 text-sm transition-colors"
                >
                  運営会社
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t border-slate-700 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">
            &copy; {currentYear} 株式会社IT&Plucktice. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;